import {
    afterRenderEffect,
    type WritableSignal,
    type ElementRef,
} from '@angular/core';

export function injectDialogSuggestionSizing(context: {
    pane: () => ElementRef<HTMLElement> | undefined;
    composer: () => ElementRef<HTMLElement> | undefined;
    host: HTMLElement;
    header: () => string;
    pageSize: WritableSignal<number>;
}) {
    afterRenderEffect((onCleanup) => {
        const pane = context.pane()?.nativeElement;
        const composer = context.composer()?.nativeElement;
        if (!pane || !composer || context.header() !== 'dialog') return;
        const update = () => {
            const list = pane.querySelector<HTMLElement>('.list');
            const row = list?.querySelector<HTMLElement>('.item');
            if (!list || !row) return;
            const rowHeight = row.getBoundingClientRect().height;
            const available =
                composer.getBoundingClientRect().top -
                (list.getBoundingClientRect().top + pane.scrollTop) -
                8;
            if (rowHeight <= 0 || available <= 0) return;
            context.pageSize.set(
                Math.max(1, Math.floor(available / rowHeight))
            );
        };
        const observer = new ResizeObserver(update);
        observer.observe(context.host);
        observer.observe(pane);
        const suggestions = pane.querySelector(
            'qpx-quippy-suggested-questions'
        );
        if (suggestions) observer.observe(suggestions);
        update();
        onCleanup(() => observer.disconnect());
    });
}
